module.exports = __webpack_public_path__ + "static/media/menu.d458076e.svg";